import { WorkflowWorkflowType } from '@calm/evexia-web-sdk';
import createWorkflowApi from '@rhg/libs/api/create-workflow-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, useMutation } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';
import {
    workflowByDefnIdForRecipientQueryOptions,
    workflowByTypeForRecipientQueryOptions,
} from '../use-workflows';

interface RestartWorkflowParameters {
    workflowDefnId: string;
    workflowType?: WorkflowWorkflowType;
}
export function useRestartWorkflow() {
    const { getAccessTokenSilently } = useAuth();
    const { activeCircle } = useActiveCircle();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({ workflowDefnId }: RestartWorkflowParameters) => {
            const api = createWorkflowApi(getAccessTokenSilently);
            const response = await api.v1RestartWorkflow({
                circleAuthorizationToken: activeCircle!.authorizationJWT!,
                recipientId: activeCircle!.recipient.id,
                workflowDefnId,
            });
            return response;
        },
        onSuccess: async (_, { workflowDefnId, workflowType }) => {
            await Promise.all([
                invalidateQueryKey(
                    workflowByDefnIdForRecipientQueryOptions.queryKey({
                        workflowDefnId,
                        recipientId: activeCircle!.recipient.id,
                    })
                ),
                invalidateQueryKey(
                    workflowByTypeForRecipientQueryOptions.queryKey({
                        recipientId: activeCircle!.recipient.id,
                        workflowType,
                    })
                ),
            ]);
        },
    });
    return {
        restartWorkflow: mutate,
        restartWorkflowAsync: mutateAsync,
        ...otherProps,
    };
}
